




























import { Component, Prop, Vue } from "vue-property-decorator";
import { Question } from "@/store/modules/lib";
@Component({
  name: "LfsRadioBoxType",
})
export default class LfsSelectBox extends Vue {
  @Prop({
    type: String,
  })
  header!: string;
  @Prop({
    type: Array,
  })
  values!: string[];
  @Prop({
    type: Array,
  })
  items!: string[];
  @Prop({
    type: Object,
  })
  value!: Question;
  get item() {
    return this.value;
  }

  changeValue() {
    // alert('bbom')
    // this.item.answerTitle =
    //   this.item.specify === "multi" ? "Выберите одно" : "Выберите несколько";
    this.$emit("changedQuestion");
  }
}
